<div class="icon" aria-hidden="true">
  <ng-container *ngIf="data$ | async as data">
    <img
      [src]="data.image"
      [appFallbackSrc]="data.fallbackImage"
      *ngIf="data.imageEnabled && data.image"
      alt=""
      decoding="async"
      loading="lazy"
    />
    <i
      class="tw-text-muted bwi bwi-lg {{ data.icon }}"
      *ngIf="!data.imageEnabled || !data.image"
    ></i>
  </ng-container>
</div>
